import { CartSelectors, getObjectKeysAsObject } from "@hopper-b2b/checkout";
import { type PaymentContext, PaymentState } from "./context";

export const NubankPaymentGuards = {
  hasUserGivenPermission: (ctx: PaymentContext) =>
    ctx[PaymentState.payment].hasAuth === true,
  isZeroBalance: (ctx: PaymentContext) => {
    const quoteBreakdown = CartSelectors.getQuoteBreakdown({
      context: ctx,
    });
    return (quoteBreakdown?.balance?.fiat?.value ?? -1) === 0;
  },
};

export const NubankPaymentGuardTypes =
  getObjectKeysAsObject(NubankPaymentGuards);
